import { LocalDateTime, Maybe } from "@flockcover/flock-svc-core-types"
import { Analytics } from "../types"

export type InsightsPeriodNumber = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15

export type InsightsPeriod = {
  number: InsightsPeriodNumber
  startedAt: LocalDateTime
  endedAt: LocalDateTime
  analytics: Maybe<Analytics>
}

export type PeriodVehicle = {
  vrn: string
  name: string
} & Omit<Analytics, "distance">

const periodVehicleSortKeyValues = [`riskScore`] as const
export const periodSortKeysMap = new Map<PeriodVehicleSortKeysFE, PeriodVehicleSortKeys>([
  [periodVehicleSortKeyValues[0], periodVehicleSortKeyValues[0]],
])
export type PeriodVehicleSortKeys = (typeof periodVehicleSortKeyValues)[number]
export const peroidVehicleSortKeyFeValues = periodVehicleSortKeyValues
export type PeriodVehicleSortKeysFE = (typeof peroidVehicleSortKeyFeValues)[number]
